"use client"

import { Link } from "react-router-dom"
import Container from "react-bootstrap/Container"
import LanguageSelector from "../LanguageSelector"

const Header = () => {
  return (
    <nav className="auth-nav">
      <Container fluid className="d-flex justify-content-between align-items-center py-3 px-lg-5">
        <Link to="/" className="d-flex align-items-center">
          <img 
            src="/assets/img/landing-images/MiABC-33.png" 
            alt="MiABC Logo" 
            style={{ height: "45px", width: "auto" }} 
          />
        </Link>
        <div className="d-flex align-items-center gap-3">
          <Link to="/login" className="nav-link-new d-none d-md-block" style={{ color: "var(--plum-bg)", fontWeight: "600", fontSize: "0.9rem" }}>
            Login
          </Link>
          <LanguageSelector />
        </div>
      </Container>
      <style>{`
        .auth-nav {
          background: transparent;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 1000;
        }
        .nav-link-new {
          text-decoration: none;
          transition: color 0.3s ease;
        }
        .nav-link-new:hover {
          color: var(--pink-bright) !important;
        }
      `}</style>
    </nav>
  )
}

export default Header
